import { ConfiguratorApi, useAuthenticatedAPIConfig } from "melco-shared-logic";
import { useCallback } from "react";

export const useChannelNames = () => {
    const authenticatedApiConfig = useAuthenticatedAPIConfig();
    return useCallback(
        async () => {
            const api = new ConfiguratorApi(authenticatedApiConfig());

            const response = await api.configuratorSessionsGetChannels();

            return response;
        },
        [authenticatedApiConfig]
    );
};
